export default {
  meta: {
    title: '本地开发-地图'
  }
};
